/**
 * Widget locations
 */
export var Slot;
(function (Slot) {
    Slot["HEADER_START"] = "AREA_HEADER_START";
    Slot["HEADER_CENTER"] = "AREA_HEADER_CENTER";
    Slot["HEADER_END"] = "AREA_HEADER_END";
    Slot["FOOTER_START"] = "AREA_FOOTER_START";
    Slot["FOOTER_CENTER"] = "AREA_FOOTER_CENTER";
    Slot["FOOTER_END"] = "AREA_FOOTER_END";
    Slot["MENU_NORTH"] = "MENU_NORTH";
    Slot["MENU_WEST"] = "MENU_WEST";
    Slot["MENU_EAST"] = "MENU_EAST";
    Slot["DOCK_WEST"] = "AREA_DOCK_WEST";
    Slot["DOCK_EAST"] = "AREA_DOCK_EAST";
    Slot["DOCK_NORTH"] = "AREA_DOCK_NORTH";
    Slot["DOCK_SOUTH"] = "AREA_DOCK_SOUTH";
    Slot["PREVIEW_WEST"] = "AREA_PREVIEW_WEST";
    Slot["PREVIEW_EAST"] = "AREA_PREVIEW_EAST";
    Slot["PREVIEW_NORTH"] = "AREA_PREVIEW_NORTH";
    Slot["PREVIEW_SOUTH"] = "AREA_PREVIEW_SOUTH";
    Slot["DRAWER_WEST"] = "AREA_DRAWER_WEST";
    Slot["DRAWER_EAST"] = "AREA_DRAWER_EAST";
    Slot["DRAWER_NORTH"] = "AREA_DRAWER_NORTH";
    Slot["DRAWER_SOUTH"] = "AREA_DRAWER_SOUTH";
    Slot["MAIN"] = "AREA_MAIN";
    Slot["MODAL"] = "MODAL";
})(Slot || (Slot = {}));
/**
 * Slot directions
 */
export var SlotDirection;
(function (SlotDirection) {
    SlotDirection["HORIZONTAL"] = "HORIZONTAL";
    SlotDirection["VERTICAL"] = "VERTICAL";
})(SlotDirection || (SlotDirection = {}));
/**
 * Slot sizes
 */
export var SlotSize;
(function (SlotSize) {
    SlotSize["NORMAL"] = "NORMAL";
    SlotSize["SMALL"] = "SMALL";
})(SlotSize || (SlotSize = {}));
export var smallSlot = [
    Slot.HEADER_START,
    Slot.HEADER_CENTER,
    Slot.HEADER_END,
    Slot.FOOTER_START,
    Slot.FOOTER_CENTER,
    Slot.FOOTER_END,
    Slot.MENU_NORTH,
];
